// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-container .alert-text[data-v-4e00c6ba] {\n  color: #e9a021;\n  cursor: default;\n}\n.home-container .wrap-picture-style[data-v-4e00c6ba] {\n  width: 100px;\n  height: 60px;\n  position: relative;\n  overflow: hidden;\n  margin: auto;\n}\n.home-container .wrap-picture-style img[data-v-4e00c6ba] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
